import * as iconClose from '../../assets/iconClose.svg'
import { Device } from '../helpers'
import { addClass, remove, removeClass } from '../helpers/DOM'
import { WindowSize } from '../helpers/windowSize'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'
import { ITimeoutMap, Timeout } from './helpers/Timeout'

const timeouts: RecursivePartial<ITimeoutMap> = {
  desktop: {
    atf: 2300,
    ref: 1200
  },
  mobile: {
    atf: 1000,
    ref: 1000
  }
}

export class Adhesion extends Slot {
  selector = 'body'
  insertPosition = 'beforeend' as InsertPosition
  slotName = 'adhesion'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)
    this.timeout = new Timeout(this, timeouts)

    this._sizes = this.adSizes

    if (Device.isMobile) {
      this.adUnitId = 'adhesion_mobile'
    } else if (Device.isTablet) {
      this.adUnitId = 'adhesion_tablet'
    } else {
      this.adUnitId = 'adhesion_desktop'
    }

    document.body.addEventListener('gumgum-inscreen-close', () => {
      if (this.model.adhesion_close) {
        this.closeAdhesion()
      }
    })
  }

  private get adSizes(): AdSizes {
    let sizes: AdSizes = []

    if (this.adUnitId === 'adhesion_mobile') {
      sizes = [
        [320, 50],
        [300, 50],
        [468, 60]
      ]
    } else if (this.adUnitId === 'adhesion_tablet') {
      sizes = [
        [728, 90],
        [468, 60],
        [320, 50],
        [300, 50]
      ]
    } else if (this.adUnitId === 'adhesion_desktop') {
      const MIN_WIDTH_FOR_970_ADS = 1005
      sizes =
        WindowSize.width >= MIN_WIDTH_FOR_970_ADS
          ? [
              [728, 90],
              [970, 90],
              [468, 60]
            ]
          : [
              [728, 90],
              [468, 60]
            ]
    }

    return sizes
  }
  /* eslint-enable no-magic-numbers */

  template(): string {
    let template = `
      <div id='${this.wrapperId}' class='adhesion_wrapper' data-wrapper='${this.adUnitId}'>
        <div id='${this.id}' class='adunit'></div>`

    if (this.model.adhesion_close) {
      template += `
          <div class='adhesion_buttons ${this.adUnitId}'>
            <span class='mv_close_button mv_unbutton' role='button' aria-label='Close ad' >
              <object id="iconCloseSvg" data=${iconClose} type="image/svg+xml">
                Close ad
              </object>
            </span>
          </div>`
    }

    template += `
      </div>
    `

    return template
  }

  cleanup(): void {
    super.cleanup()
    this.closeAdhesion()
  }

  private closeAdhesion(): void {
    const el = this.wrapper
    if (el !== null) {
      window.googletag.destroySlots([this.gSlot])
      remove(el)
    }
    removeClass(document.body, 'adhesion')
  }

  sizeContainers({ height, width } = this): void {
    this.resetSizeClasses()
    removeClass(this.wrapper, 'adhesion_container')
    addClass(document.body, 'adhesion')
    addClass(this.wrapper, 'mv-dynamic-size')

    if (isStandardAd([width, height])) {
      this.setupCloseButton()
      addClass(this.wrapper, 'adhesion_container') // Create container
      this.wrapper.style.minHeight = `${String(height)}px`
      this.wrapper.style.display = 'flex' // 'block'
    }

    this.sizeIframe()
  }

  private setupCloseButton(): void {
    if (!this.model.adhesion_close) {
      /* no close button! */ return
    }
    // Make Close Button Work
    const closeButton = this.wrapper.querySelector(
      '.mv_close_button'
    ) as HTMLElement
    closeButton.addEventListener('click', () => {
      this.closeAdhesion()
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }

      return false
    })
  }
}

export function isStandardAd(size: AdSize): boolean {
  return size[0] > 1 && size[1] > 1
}
